import './component.scss'

document.addEventListener('DOMContentLoaded', () => {
  const mainElement = document.querySelector('main.subsidies[data-bookmark-count]')
  if (!mainElement) return

  const bookmarkCount = parseInt(mainElement.dataset.bookmarkCount, 10) || 0

  if (typeof window.dataLayer !== 'undefined') {
    window.dataLayer.push({
      event: 'view_bookmark_page',
      bookmark_count: bookmarkCount
    })
  }
})
